export default "__VITE_ASSET__DYEO20xm__"